import React, { useState } from 'react';
import styled from '@emotion/styled';

import SlickBar from 'components/SlickBar';
import ToolboxThumbnail from '../elements/ToolboxThumbnail';
import ImageModal from 'components/ImageModal';

import vw from 'styles/utils';

import toolboxData from 'data/toolbox';

function Toolbox() {
  const [isShowModal, setIsShowModal] = useState(false);
  // const [imageSrc, setImageSrc] = useState(null);

  const handleClickCloseButton = () => {
    setIsShowModal(false);
  }

  // const handleShowModal = (index) => {
  //   setImageSrc(toolboxData[index].src);
  //   setIsShowModal(true);
  // }

  return (
    <Root>
      <SlickBar
        icon={require('assets/images/icons/toolbox.png')}
        title="淨零工具箱"
      >
        {
          toolboxData.map((data, index) => (
              <ToolboxThumbnail
                title={data.title}
                category={data.category}
                src={data.src}
                url={data.url}
                // onClick={() => handleShowModal(index)}
                key={data.title}
              />
          ))
        }
      </SlickBar>
      <ImageModal
        show={isShowModal}
        // srcUrl={imageSrc}
        onClickCloseButton={handleClickCloseButton}
      />
    </Root>
  )
}

const Root = styled.section`
  ${vw('margin-bottom', 30, 60)}
`;

export default Toolbox
